module.exports = __webpack_public_path__ + "img/sm_cal_green.aa630bd6.svg";